// extracted by mini-css-extract-plugin
export default {"GreenDream":"GreenDream_GreenDream__4Ebop","Logo":"GreenDream_Logo__fL8OC"};